import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { getCharacter, refreshCharacterGameData } from '../../actions/CharacterAction';
import { l10n } from '../../i18n/Localization';
import CharacterSerializer from '../../models/characters/CharacterSerializer';
import BackButton from '../BackButton';
import RefreshCharacterGameDataView from './RefreshCharacterGameDataView';

class RefreshCharacterGameDataPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            refreshCharacterGameDataStarted: false,
        };

        this.cachedCharacter = null;
    }

    componentDidMount() {
        const { characterId, character } = this.props;

        if (characterId !== undefined && character === null) {
            this.props.getCharacter(characterId);
        }
    }

    createCachedCharacter() {
        const { character } = this.props;

        if (character !== null) {
            return CharacterSerializer.deserialize(CharacterSerializer.serialize(character));
        } else {
            return null;
        }
    }

    prepareProperties() {
        if (this.cachedCharacter === null) {
            this.cachedCharacter = this.createCachedCharacter();
        }
    }

    refreshCharacterGameData = () => {
        this.setState({
            refreshCharacterGameDataStarted: true,
        });

        this.props.refreshCharacterGameData(this.cachedCharacter);
    }

    render() {
        this.prepareProperties();

        const { refreshCharacterGameDataCompleted, refreshCharacterGameDataMessage, refreshCharacterGameDataError } = this.props;
        const { refreshCharacterGameDataStarted } = this.state;

        if (refreshCharacterGameDataStarted && refreshCharacterGameDataCompleted && refreshCharacterGameDataError === null) {
            return <Redirect to={`/characters/${this.cachedCharacter.id}`} />;
        }

        let refreshCharacterGameDataHint;
        let isRefreshingGameData;

        if (refreshCharacterGameDataStarted) {
            if (refreshCharacterGameDataCompleted) {
                refreshCharacterGameDataHint = (refreshCharacterGameDataError !== null) ? refreshCharacterGameDataError.message : refreshCharacterGameDataMessage;
                isRefreshingGameData = false;
            } else {
                refreshCharacterGameDataHint = '';
                isRefreshingGameData = true;
            }
        } else {
            refreshCharacterGameDataHint = '';
            isRefreshingGameData = false;
        }

        let actionDiv;

        if (this.cachedCharacter !== null) {
            actionDiv = (
                <div className="d-flex justify-content-end align-items-center">
                    {isRefreshingGameData ? <div className="spinner-border mr-1"></div> : null}
                    <span className="mr-3">{refreshCharacterGameDataHint}</span>
                    <button className="btn btn-primary" type="button" onClick={this.refreshCharacterGameData} disabled={!this.cachedCharacter.isVerified || !refreshCharacterGameDataCompleted}>{l10n.action.refreshGameData}</button>
                </div>
            );
        } else {
            actionDiv = null;
        }

        let content;

        if (this.cachedCharacter !== null) {
            content = (
                <div className="container mt-3">
                    <div className="d-flex justify-content-between mb-3">
                        <BackButton disabled={!refreshCharacterGameDataCompleted} />
                    </div>
                    <div className="mb-3">
                        <div>{l10n.refreshCharacterGameDataPage.game}: {this.cachedCharacter.gameCode.wireName}</div>
                        <div>{l10n.refreshCharacterGameDataPage.identificationName}: {this.cachedCharacter.identificationName}</div>
                        <div>{l10n.refreshCharacterGameDataPage.verificationNumber}: {this.cachedCharacter.verificationNumber}</div>
                        <div className="text-success">{l10n.refreshCharacterGameDataPage.verifyCharacter}</div>
                    </div>
                    <div className="mb-3">
                        <RefreshCharacterGameDataView character={this.cachedCharacter} />
                    </div>
                    {actionDiv}
                </div>
            );
        } else {
            content = (
                <div className="container mt-3">
                    <div className="d-flex justify-content-center">
                        <div className="spinner-border"></div>
                    </div>
                </div>
            );
        }

        return (
            <div className="RefreshCharacterGameDataPage">
                <Helmet>
                    <link rel="icon" type="image/x-icon" href={`${process.env.PUBLIC_URL}/favicon.ico`} />
                    <meta name="description" content={l10n.refreshCharacterGameDataPage.pageTitle} />
                    <title>{l10n.refreshCharacterGameDataPage.pageTitle} - {l10n.productName}</title>
                </Helmet>
                {content}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const characters = state.characterState.getCharacterCharacters;
    const { characterId } = ownProps.match.params;

    const character = characters.has(characterId) ? characters.get(characterId) : null;

    return {
        characterId: characterId,
        character: character,
        refreshCharacterGameDataCompleted: state.characterState.refreshCharacterGameDataCompleted,
        refreshCharacterGameDataMessage: state.characterState.refreshCharacterGameDataMessage,
        refreshCharacterGameDataError: state.characterState.refreshCharacterGameDataError,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCharacter: (characterId) => {
            dispatch(getCharacter(characterId));
        },
        refreshCharacterGameData: (character) => {
            dispatch(refreshCharacterGameData(character));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RefreshCharacterGameDataPage);
